export default __webpack_public_path__ + "static/media/gumballmachine.b34dae1c.png";